export enum AuthApiEndpoints {
  SEND_OTP = 'mock-tests/users/send-otp',
  VERIFY_OTP = 'mock-tests/users/verify-otp',
  SIGNUP = 'mock-tests/users/signup',
  COLLEGES = 'config/colleges',
  YEARS = 'config/years',
  GET_PROFILE = 'mock-tests/users/get-user-details',
}

export enum TestSeriesApiEndpoints {
  GET_ALL_TEST_SERIES = 'examinations/all',
  GET_EXAM_QUESTIONS_SUFFIX = 'questions',
  START_EXAM_SUFFIX = 'start',
  SUBMIT_EXAM = 'examinations/submit',
  GET_EXAM_RESULT = 'examinations/result',
  GET_SECTION_QUESTION_MAP_SUFFIX = 'section-question-map',
  GET_QUESTION_RESULT = 'examinations/question-result',
  COMPLETE_EXAMINATIONS = 'examinations/complete',
}

export enum DashboardApiEndpoints {
  GET_TOP_TWO_EXAMS = 'examinations/top-two-exam',
  GET_STUDENT_STATS = 'examinations/student/stats',
  GET_RECENT_TESTS = 'examinations/student/recent-tests',
}

export enum BookmarkApiEndpoints {
  GET_BOOKMARKS = 'mock-test/bookmarks/get-all-book-mark',
  TRACK_EVENT = 'events/track',
  CREATE_BOOK_MARK = 'mock-test/bookmarks/create-book-mark',
  REMOVE_BOOK_MARK = 'mock-test/bookmarks',
}

export enum PerformanceApiEndpoints {
  STUDENT_PERFORMANCE_SUMMARY = 'examinations/student/performance-summary',
  STUDENT_TEST_HISTORY = 'examinations/student/test-history',
  TEST_STUDENT_PERFORMANCE_SUFFIX = 'student-performance',
  ATTEMPTS = 'attempts',
  ANSWER_CHANGES_SUFFIX = 'answer-changes',
  ANSWER_CHANGED_QUESTIONS_SUFFIX = 'answer-changes/questions',
  PREP_INSIGHTS_SUFFIX = 'prep-insights',
  SUBJECT_NEEDS_SUFFIX = 'subject-needs',
}
